import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { Cf2MaterialModule } from '@modules/cf2-material/cf2-material.module';

@Component({
    selector: 'cf2-search-input',
    template: `
        <mat-form-field floatLabel="always" appearance="outline">
            <div class="container">
                <span class="material-icons search">search</span>
                <a href="javascript: void(0);" class="material-icons clear" (click)="clearForm()">clear</a>

                <input #searchInput matInput aria-label="Search" autocomplete="off" [formControl]="ctrl"/>
            </div>
        </mat-form-field>
    `,
    styleUrls: ['./search-input.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
      CommonModule,
      ReactiveFormsModule,
      FormsModule,
      Cf2MaterialModule,
      RouterModule,
      MatFormFieldModule,
      MatInputModule,
    ]
})
export class SearchInputComponent {
  @ViewChild('searchInput', { read: ElementRef }) searchInput;

  @Input() ctrl = new UntypedFormControl();

  public clearForm() {
    // clear the value then raise a keyup event
    if (this.searchInput !== undefined) {
      const input = (this.searchInput.nativeElement as undefined) as HTMLInputElement;

      const event = new KeyboardEvent('keyup', {
        bubbles: true,
        cancelable: true,
        shiftKey: false,
      });

      input.value = '';

      input.dispatchEvent(event);
    }
    if (this.ctrl) {
      this.ctrl.patchValue('');
    }
  }
}
